import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUsers, FaStar, FaArrowRight } from "react-icons/fa";
import { CLUBS_DATA } from "../../../data/clubsData";
import { AppDownloadModal } from "../../common/AppDownloadModal";
import "./HomeClubsSection.css";
import "./ResponsiveHomeClubs.css";

export const HomeClubsSection = () => {
  const [selectedClub, setSelectedClub] = useState(null);
  const navigate = useNavigate();

  // Show top 4 featured recipe clubs on homepage
  const featuredClubs = CLUBS_DATA.slice(0, 4);

  return (
    <section className="home-clubs-section">
      <div className="home-clubs-container">
        <div className="home-clubs-header">
          <div className="header-text-group">
            <span className="clubs-badge">COMMUNITY CLUBS</span>
            <h2>Popular Recipe Clubs</h2>
            <p>
              Connect with passionate home cooks, share secret family recipes, and learn from top foodies in live interactive clubs.
            </p>
          </div>
          <button
            className="explore-all-btn"
            onClick={() => navigate("/clubs")}
          >
            Explore All Clubs <FaArrowRight />
          </button>
        </div>

        <div className="home-clubs-grid">
          {featuredClubs.map((club) => (
            <div key={club.id} className="home-club-card">
              <div className="card-top-image">
                <img src={club.image} alt={club.name} />
                <span className="club-rating">
                  <FaStar className="star-icon" /> {club.rating}
                </span>
              </div>

              <div className="card-body">
                <div className="club-tags">
                  {club.tags.slice(0, 2).map((tag, idx) => (
                    <span key={idx} className="club-tag-pill">
                      {tag}
                    </span>
                  ))}
                </div>

                <h3 className="club-title">{club.name}</h3>
                <p className="club-slogan">{club.slogan}</p>

                <div className="club-meta-bar">
                  <span className="meta-members">
                    <FaUsers /> {club.membersCount} Members
                  </span>
                  <span className="meta-host">by {club.host}</span>
                </div>

                <button
                  className="join-club-btn"
                  onClick={() => setSelectedClub(club)}
                >
                  Join Club
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <AppDownloadModal
        isOpen={!!selectedClub}
        onClose={() => setSelectedClub(null)}
        title={selectedClub ? `Join ${selectedClub.name}` : "Join Recipe Club"}
      />
    </section>
  );
};
